import React from "react";

import TimeslotRuleItem from "./TimeslotRuleItem";
import {
  TimeslotRuleAdbreakSelect,
  TimeslotRuleCountSelect,
  TimeslotRulePlaylistSelect,
} from "./TimeslotRuleItemSelect";
import { TimeslotColumns } from "../../../types";

import type { JSX } from "react";
import type { ConnectDragSource } from "react-dnd";

import type { TimeslotRandomRule } from "../../../api/FastAPI.types";

interface TimeslotRuleRandomProps {
  rule: TimeslotRandomRule;
  onClickDelete: (uuid: string) => void;
  isDragging: boolean;
  isDragDisabled: boolean;
  dragRef: ConnectDragSource;
}

function TimeslotRuleRandom({
  rule,
  onClickDelete,
  isDragging,
  dragRef,
  isDragDisabled,
}: TimeslotRuleRandomProps): JSX.Element {
  const columns = {
    [TimeslotColumns.Rank]: rule.rank,
    [TimeslotColumns.Mode]: rule.mode,
    [TimeslotColumns.Source]: <TimeslotRulePlaylistSelect ruleId={rule.uuid} />,
    [TimeslotColumns.Count]: <TimeslotRuleCountSelect ruleId={rule.uuid} />,
    [TimeslotColumns.Ads]: <TimeslotRuleAdbreakSelect ruleId={rule.uuid} />,
  };

  return (
    <TimeslotRuleItem
      columns={columns}
      dragRef={dragRef}
      isDragDisabled={isDragDisabled}
      isDragging={isDragging}
      onClickDelete={onClickDelete}
      uuid={rule.uuid}
    />
  );
}

export default TimeslotRuleRandom;
